<template>
  <div class="container-fluid base-container text-center full-width">
    <div class="container-fluid full-width">
      <div class="row align-items-start full-width">
        <offer_card
                    icon="fas fa-shield-alt"
                    :content="$t('landing_components.hosting_services.physical.content')"
                    :title="$t('landing_components.hosting_services.physical.title')"/>

        <offer_card
                    icon="fas fa-heartbeat"
                    :content="$t('landing_components.hosting_services.utilities.content')"
                    :title="$t('landing_components.hosting_services.utilities.title')"/>

        <offer_card
                    icon="fas fa-ethernet"
                    :content="$t('landing_components.hosting_services.connectivity.content')"
                    :title="$t('landing_components.hosting_services.connectivity.title')"/>
      </div>
      <div class="row align-items-start full-width">
        <offer_card optional="yes"
                    icon="fas fa-network-wired"
                    :content="$t('landing_components.hosting_services.networking.content')"
                    :title="$t('landing_components.hosting_services.networking.title')"/>

        <offer_card optional="yes"
                    icon="fab fa-fort-awesome"
                    :content="$t('landing_components.hosting_services.cybersecurity.content')"
                    :title="$t('landing_components.hosting_services.cybersecurity.title')"/>

        <offer_card optional="yes"
                    icon="fas fa-leaf"
                    :content="$t('landing_components.hosting_services.beys.content')"
                    :title="$t('landing_components.hosting_services.beys.title')"/>
      </div>

    </div>
  </div>

</template>

<script>
import offer_card from "@/components/generic/offer_card";

export default {
  name: "offers",
  components: {offer_card},
}
</script>

<style scoped>

.base-container {
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.7)), url('/images/bg2.webp')
}

.full-width {
  margin: 0;
  padding: 0;
  width: 100%;
}

@media screen and (max-width: 1150px) {
  .row {
    display: flex;
    flex-direction: column;
  }
}
</style>